import {useQuery} from '@tanstack/react-query'

import {SettingsService} from 'services/api'

interface GetUserImportLinkQueryOptions {
  enabled?: boolean
  refetchOnWindowFocus?: boolean | 'always'
}

export const GET_USER_IMPORT_LINK_QUERY_KEY = 'getUserImportLink'

export const useGetUserImportLinkQuery = ({
  enabled = true,
  refetchOnWindowFocus,
}: GetUserImportLinkQueryOptions) => {
  return useQuery({
    queryKey: [GET_USER_IMPORT_LINK_QUERY_KEY],
    queryFn: () => SettingsService.getLink(),
    enabled,
    select: ({data}) => data,
    refetchOnWindowFocus,
  })
}
